import Ajax from '@utils/ajax';

export default {
  search(group, data, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/recommendations`,
      data: data,
      ...options,
    });
  },

  fetch(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/recommendations/fetch`,
      ...options,
    });
  },

  fetch_with_rec_objects(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/recommendations/fetch_with_rec_objects`,
      ...options,
    });
  },

  create(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/recommendations`,
      data: data,
      ...options,
    });
  },

  update(group, rec, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/recommendations/${rec.id}`,
      data: {
        rec: data,
        _method: 'PUT',
      },
      ...options,
    });
  },
};
